import React, { useState } from "react";

import "./artifacts.css";

const CHECKS = [
	"Prompt injection defense: untrusted input cannot rewrite the agent's instructions",
	"Tool permissions are scoped to least privilege, not broad API keys",
	"High-impact actions (payments, deletes, sends) require human approval",
	"Outputs are validated before they trigger a downstream action",
	"Rate limits and spend caps are enforced per agent and per user",
	"Secrets are never placed in the prompt or the model context",
	"Every tool call is logged with enough detail to reconstruct an incident",
	"The agent runs in a sandbox that limits blast radius if it is compromised",
];

const AgentSecurityChecklist = () => {
	const [checked, setChecked] = useState({});

	const count = Object.values(checked).filter(Boolean).length;
	const percent = Math.round((count / CHECKS.length) * 100);
	const color =
		percent >= 88 ? "#2f855a" : percent >= 50 ? "#dd6b20" : "#c53030";

	const toggle = (i) =>
		setChecked((prev) => ({ ...prev, [i]: !prev[i] }));

	return (
		<div className="artifact-card">
			<div className="artifact-kicker">Interactive · Free checklist</div>
			<div className="artifact-title">
				Agent Pre-Deployment Security Checklist
			</div>
			<div className="artifact-intro">
				Eight controls to clear before an agentic system touches
				production. Check what is genuinely true today.
			</div>

			{CHECKS.map((c, i) => (
				<label className="artifact-check" key={i}>
					<input
						type="checkbox"
						checked={!!checked[i]}
						onChange={() => toggle(i)}
					/>
					<span className="artifact-check-text">{c}</span>
				</label>
			))}

			<div className="artifact-result">
				<div className="artifact-score-row">
					<span className="artifact-score">{percent}%</span>
					<span
						className="artifact-tier"
						style={{ color }}
					>
						{count} of {CHECKS.length} controls in place
					</span>
				</div>
				<div className="artifact-bar">
					<div
						className="artifact-bar-fill"
						style={{ width: `${percent}%`, background: color }}
					/>
				</div>
				<div className="artifact-readout">
					Anything short of every box is an open door. Agentic systems
					fail at the weakest control, not the average one.
				</div>
			</div>
		</div>
	);
};

export default AgentSecurityChecklist;
